export function normalizeHeader(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9%]+/g, " ")
    .trim();
}

export function canonicalSubject(value) {
  return String(value || "Geral").trim() || "Geral";
}

export function subjectMatchesName(subject, target) {
  return normalizeHeader(subject) === normalizeHeader(target);
}
